// Whitelisted CMS link keys → app routes (L6.5). The admin edits link labels,
// order and visibility in the CMS, but never types a URL: each item carries a
// `key` from NAV_KEYS / FOOTER_LEGAL_KEYS (section-types.ts) and the route is
// resolved here. Adding a destination = one entry here + one key in the enum.
import type { FOOTER_LEGAL_KEYS, NAV_KEYS } from './section-types';

export type NavKey = (typeof NAV_KEYS)[number];
export type FooterLegalKey = (typeof FOOTER_LEGAL_KEYS)[number];

export const NAV_ROUTES: Record<NavKey, string> = {
  home: '/',
  // `/` IS the catalogue (ADR-018) — pointing `deals` at `/deals` would make
  // every page emit an internal link to a 301 (netlify.toml, SEO lot 1).
  deals: '/',
  about: '/about',
  faq: '/faq',
  sell: '/sell',
  contact: '/contact',
};

export const FOOTER_LEGAL_ROUTES: Record<FooterLegalKey, string> = {
  privacy: '/legal/privacy',
  terms: '/legal/terms',
  cookies: '/legal/cookies',
};
